import { h, render } from "preact";
import { SearchBar } from "./searchBar";

// Optional: add translations or other props if required
const resultsInfoNode = document.getElementById("results-info");

if (resultsInfoNode) {
  render(<SearchBar showMobileMenu={false}  showExtraSubmitButton={true} instanceId="resultsSearch"/>, resultsInfoNode);
}